import {
  Component,
  ChangeDetectionStrategy,
  Input,
  AfterViewInit,
  OnDestroy,
  ViewChildren,
  QueryList,
  ElementRef,
  Output,
  EventEmitter,
  ViewChild,
  ChangeDetectorRef,
  TemplateRef,
} from '@angular/core';
import { PlayerModel } from '@modules/media/models/player.model';

@Component({
  selector: 'mb-thumb-control',
  templateUrl: './thumb-control.component.html',
  styleUrls: ['./thumb-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThumbControlComponent implements AfterViewInit, OnDestroy {
  public showScrollIndicator = false;
  private stopAnimation = false;

  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;

  @ViewChildren('thumbItem') thumbItem!: QueryList<ElementRef>;

  @Output() closeThumb = new EventEmitter();

  @Output() positionUpdated = new EventEmitter();

  @Input() dragHandler!: TemplateRef<any>;
  @Input() maxHeight!: number;

  public _player!: PlayerModel;
  @Input()
  set player(v: PlayerModel) {
    this._player = v;
    this.elRef.nativeElement.style.setProperty('--thumb-item-ratio', v.playerData.ratio);
  }
  get player() {
    return this._player;
  }

  constructor(private elRef: ElementRef, private cdr: ChangeDetectorRef) {}

  scrollDown() {
    this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
    this.showScrollIndicator = false;
    this.cdr.detectChanges();
  }

  checkMobileHeight() {
    this.elRef.nativeElement.style.setProperty('--mobile-thumb-height', `${window.innerHeight}px`);
  }

  checkScroll() {
    const el = this.scrollContainer.nativeElement;

    const show = el.scrollHeight > el.clientHeight && el.scrollTop < 50;
    if (show !== this.showScrollIndicator) {
      this.showScrollIndicator = show;
      this.cdr.detectChanges();
    }
  }

  setPosition(position: number) {
    this.player.setPosition(position);
    this.positionUpdated.emit();
  }

  ngAfterViewInit() {
    this.scrollContainer.nativeElement.addEventListener('scroll', this.checkScroll.bind(this));
    this.checkMobileHeight();
    this.checkScroll();
    const player = this.player.videoEl;

    const drawFn = () => {
      if (!this.stopAnimation) {
        requestAnimationFrame(drawFn);
      }
      for (let i = 0; i < 4; i++) {
        const canvas = this.thumbItem.get(i)?.nativeElement;
        const parent = canvas.parentNode;
        const scale = parent.videoWidth / player.clientWidth / 2;
        const ctx = canvas.getContext('2d');
        canvas.width = player.videoWidth;
        canvas.height = player.videoHeight;
        canvas.style.transform = `scale(${scale})`;
        ctx.drawImage(this.player.videoEl, 0, 0, player.videoWidth, player.videoHeight);
      }
    };
    drawFn();
  }

  ngOnDestroy() {
    this.stopAnimation = true;
  }
}
